// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Localidades_BuscabairroResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * ResponseContract for buscaBairro() /localidades/buscaBairro
 *
 * Proxy to locations-service (Go microservice).
 * Returns a single neighborhood (bairro) record by ID.
 */
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export interface Localidades_BuscabairroResponseDados {
id?: number
name?: string
city_id?: number
}

export type Localidades_BuscabairroResponse = ApiResponse<Localidades_BuscabairroResponseDados>;

registerResponseContract('Localidades_BuscabairroResponse', {
  id:      { type: 'number',  required: false },
  name:    { type: 'string',  required: false },
  city_id: { type: 'number',  required: false },
})
